<app-upload-dropzone-border>
  <div class="mx-auto flex flex-col items-center p-14 text-center">
    <span class="font-medium text-blue-500"> Kliknij, aby wybrać pliki </span>
    <span>lub</span>
    <span class="font-medium">upuść pliki tutaj, aby je przesłać</span>
    <span class="text-sm font-medium text-gray-500">
      Maksymalna wielkość dodawanych plików: {{ maxFileSize() | filesize }}.
    </span>
    @if (maxNumberOfFiles() > 0) {
      <span class="text-sm font-medium text-gray-500">
        Maksymalna ilość plików: {{ maxNumberOfFiles() }}.
      </span>
    }
  </div>
</app-upload-dropzone-border>
